import React from "react";
import ReactDOM from "react-dom";

import * as Sentry from "@sentry/react";

import App from "./App";
import OrganizationThemeContext from "./context/OrganizationThemeContext";

Sentry.init({
  dsn: "https://f0b24e13c70f44eeb35f337a1efdd974@o1336474.ingest.sentry.io/6621512",
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <OrganizationThemeContext>
    <App />
  </OrganizationThemeContext>,
  document.getElementById("root")
);

// import React, { useEffect, useState } from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import keycloak from './keycloak';

// const initOptions = {
//   onLoad: 'login-required',
//   checkLoginIframe: false, // Disable if you are using a secure environment
// };
// keycloak.init(initOptions).then((authenticated) => {
//   if (authenticated) {
//     ReactDOM.render(<App />, document.getElementById('root'));
//   } else {
//     window.location.reload();
//   }
// }).catch((error) => {
//   console.error('Keycloak initialization failed:', error);
// });
